export default __webpack_public_path__ + "static/media/proptech.868b2950.png";